import React from 'react';
import { Checkbox } from '@mui/material';

import { rowCheckboxClicked } from '../../store/actions/grid';
import { useAppDispatch, useAppSelector } from '../hooks';

const checkboxClassName = 'project-row-checkbox';

// to hide a grid row checkbox until its row is hovered (unless it is already checked)
const checkboxRevealOnHoverStyles = {
  opacity: 0,
  visibility: 'hidden',
  transition: 'opacity 0.1s, visibility 0.1s',
  '&.Mui-checked': { opacity: 1, visibility: 'visible' },
} as const;

// for the row containing a grid row checkbox, to reveal it on hover
export const revealRowCheckboxOnHoverStyles = {
  [`&:hover .${checkboxClassName}`]: { opacity: 1, visibility: 'visible' },
} as const;

export function ProjectGridRowCheckbox(props: { readonly rowId: string }) {
  const dispatch = useAppDispatch();
  const checked = useAppSelector((state) => state.grid.checkedRows.includes(props.rowId));

  return (
    <Checkbox
      className={checkboxClassName}
      size="small"
      checked={checked}
      sx={checkboxRevealOnHoverStyles}
      onChange={() => undefined}
      onClick={(event) => {
        event.stopPropagation();
        dispatch(rowCheckboxClicked(props.rowId, event.shiftKey));
      }}
    />
  );
}
